import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class ContactAddressService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/hcps/%(contact_id)s/addresses`);
  }

  // Universe HCP edit uses empty company_id; Express cannot match /companies//…
  // so fall back to "0" (backend resolves that to commonDB).
  private withCompany(urlParams: any = {}) {
    return {
      ...urlParams,
      company_id: urlParams.company_id || '0',
    };
  }

  list(urlParams: any = {}, apiParams: any = {}): Observable<any> {
    return super.list(this.withCompany(urlParams), apiParams);
  }

  get(id: any, urlParams: any = {}, apiParams: any = {}): Observable<any> {
    return super.get(id, this.withCompany(urlParams), apiParams);
  }

  create(model: any, urlParams: any = {}, apiParams: any = {}, options: any = {}): Observable<any> {
    return super.create(model, this.withCompany(urlParams), apiParams, options);
  }

  update(model: any, urlParams: any = {}, apiParams: any = {}, options: any = {}): Observable<any> {
    return super.update(model, this.withCompany(urlParams), apiParams, options);
  }

  delete(model: any, urlParams: any = {}, apiParams: any = {}): Observable<any> {
    return super.delete(model, this.withCompany(urlParams), apiParams);
  }
}
